import { atsApiQuery } from '..';

export const approvalBuildersApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getApprovalsList: builder.query({
        providesTags: ['GetApprovalsList'],
        transformResponse: (response) => response?.data,
        query: ({ type }) => {
          return {
            method: 'get',
            url: `/approvals?type=${type}`,
          };
        },
      }),

      getApprovalById: builder.query({
        providesTags: ['GetApprovalById'],
        transformResponse: (response) => response?.data,
        query: ({ approvalId }) => {
          return {
            method: 'get',
            url: `/approvals/${approvalId}`,
          };
        },
      }),

      getApprovalsByEntity: builder.query({
        providesTags: ['getApprovalsByEntity'],
        transformResponse: (response) => response?.data,
        query: ({ id, type }) => {
          return {
            method: 'get',
            url: `/approvals/ongoing?entity_id=${id}&type=${type}`,
          };
        },
      }),

      getApprovalsCompletedByEntity: builder.query({
        providesTags: ['getApprovalsCompletedByEntity'],
        transformResponse: (response) => response?.data,
        query: ({ id, type }) => {
          return {
            method: 'get',
            url: `/approvals/completed?entity_id=${id}&type=${type}`,
          };
        },
      }),

      getApprovalsSettings: builder.query({
        providesTags: ['GetApprovalsSettings'],
        transformResponse: (response) => response?.data,
        query: () => {
          return {
            method: 'get',
            url: `/approvals/settings`,
          };
        },
        staleTime: 0,
      }),

      createApproval: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload }) => {
          return {
            method: 'post',
            url: `/approvals`,
            data: { ...payload },
          };
        },
        invalidatesTags: (result) => {
          if (result?.id) {
            return [{ type: 'GetApprovalsList' }];
          }
          return [];
        },
      }),

      approvalRemainder: builder.mutation({
        transformResponse: (response) => response,
        query: ({ approvalUserId, approvalId }) => {
          return {
            method: 'post',
            url: `/approvals/${approvalId}/request_notification`,
            data: { approval_user_id: approvalUserId },
          };
        },
        invalidatesTags: (result) => {
          if (result?.id) {
            return [{ type: 'GetApprovalsByJob' }];
          }
          return [];
        },
      }),

      approveRejectAction: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload }) => {
          return {
            method: 'post',
            url: `/approval_logs`,
            data: { ...payload },
          };
        },
        invalidatesTags: (result) => {
          if (result?.id) {
            return [{ type: 'GetApprovalsByJob' }];
          }
          return [];
        },
      }),

      updateApproval: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ approvalId, payload }) => {
          return {
            method: 'put',
            url: `/approvals/${approvalId}`,
            data: { ...payload },
          };
        },
        invalidatesTags: (result) => {
          if (result?.id) {
            return [{ type: 'GetApprovalById' }, { type: 'GetApprovalsList' }];
          }
          return [];
        },
      }),

      deleteApproval: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ approvalId, payload }) => {
          return {
            method: 'delete',
            url: `/approvals/${approvalId}`,
          };
        },
        invalidatesTags: (result) => {
          return [{ type: 'GetApprovalById' }, { type: 'GetApprovalsList' }];
        },
      }),

      updateApprovalSettings: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload }) => {
          return {
            method: 'put',
            url: `/approvals/settings`,
            data: { ...payload },
          };
        },
        invalidatesTags: () => {
          return [
            { type: 'GetApprovalsSettings' },
            { type: 'GetApprovalsList' },
          ];
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetApprovalsListQuery,
  useGetApprovalsSettingsQuery,
  useLazyGetApprovalByIdQuery,
  useGetApprovalsByEntityQuery,
  useLazyGetApprovalsByEntityQuery,
  useGetApprovalsCompletedByEntityQuery,
  useLazyGetApprovalsCompletedByEntityQuery,
  useApprovalRemainderMutation,
  useCreateApprovalMutation,
  useUpdateApprovalMutation,
  useDeleteApprovalMutation,
  useApproveRejectActionMutation,
  useUpdateApprovalSettingsMutation,
} = approvalBuildersApi;
